import { getAppConfig } from '@/helpers';
import BranchInterface from '@/interfaces/BranchInterface';
import ProductCategoryInterface from '@/interfaces/ProductCategoryInterface';
import axios from 'axios';
import Product from '@/classes/Product';
import ProductInterface from '@/interfaces/ProductInterface';

class IoProductAPI {
  static getAll(branch: string, business = false): Promise<Product[]> {
    return new Promise((resolve, reject) => {
      const params: Record<string, string> = {
        action: 'io_products',
        endpoint: 'getAll',
        branch,
      };

      if (business) {
        params.customerType = 'business';
      }

      axios.get(getAppConfig('ajaxUrl'), {
        params,
      }).then((response) => {
        const products = [] as Product[];
        Object.values(response.data?.data?.products || {}).forEach((productAttributes) => {
          products.push(new Product(productAttributes as ProductInterface));
        });
        resolve(products);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static getAllWithPrices(params: Record<string, unknown>): Promise<Product[]> {
    return new Promise((resolve, reject) => {
      axios.get(getAppConfig('ajaxUrl'), {
        params: {
          action: 'io_products',
          endpoint: 'getAllWithPrices',
          ...params,
        },
      }).then((response) => {
        const products = [] as Product[];
        Object.values(response.data?.data?.products || {}).forEach((productAttributes) => {
          products.push(new Product(productAttributes as ProductInterface));
        });
        resolve(products);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static validateCoupon(code: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      axios.get(getAppConfig('ajaxUrl'), {
        params: {
          action: 'io_products',
          endpoint: 'validateCoupon',
          code,
        },
      }).then((response) => {
        resolve(response?.data?.data?.valid || false);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static getCategories(tree = false): Promise<ProductCategoryInterface[]> {
    return new Promise((resolve, reject) => {
      axios.get(`${getAppConfig('env.API_BASE_PATH')}io-product`, {
        params: {
          endpoint: 'getCategories',
          tree,
        },
      }).then((response) => {
        resolve(response?.data?.data?.categories || []);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static getBranches(): Promise<BranchInterface[]> {
    return new Promise((resolve, reject) => {
      axios.get(`${getAppConfig('env.API_BASE_PATH')}io-product`, {
        params: {
          endpoint: 'getBranches',
        },
      }).then((response) => {
        resolve(response.data?.data?.branches || []);
      }).catch((e) => {
        reject(e);
      });
    });
  }
}

export default IoProductAPI;
